import { render } from "./RequestItem.vue?vue&type=template&id=522c6b5d&scoped=true"
import script from "./RequestItem.vue?vue&type=script&lang=js"
export * from "./RequestItem.vue?vue&type=script&lang=js"

import "./RequestItem.vue?vue&type=style&index=0&id=522c6b5d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-522c6b5d"

export default script